/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { useRoutes } from 'react-router-dom';
import App from './App';
import Login from './Login';
import Error404 from './utils/Error404';

export const AVAILABLE_PATHS = [
    { 
        path: '/',
        element: <Login /> 
    },
    { 
        path: '/login',
        element: <Login />
    },
    { 
        path: '/dashboard',
        element: <App /> 
    },
    {
        path: '/cooperative/dashboard', 
        element: <App />
    },
    { 
        path: '/cooperative/login/:data',
        element: <Login />
    },
    {
        path: '*',
        element: <Error404 />
    },
]

const PrivateRouter = () => {

    window.history.pushState(null, document.title, window.location.href);
    window.addEventListener('popstate', function (event){
        window.history.pushState(null, document.title,  window.location.href);
    });

    let element = useRoutes(AVAILABLE_PATHS);

    return element;
}

export default PrivateRouter
